import { render, staticRenderFns } from "./GastoForm.vue?vue&type=template&id=5729fafe&scoped=true&"
import script from "./GastoForm.vue?vue&type=script&lang=js&"
export * from "./GastoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5729fafe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VDatePicker,VSelect,VTextField,VTextarea})
